import ContactDirectory from "@/components/ContactDirectory";

export default function LandFreight({ initialQuery = "" }) {
  return (
    <ContactDirectory
      initialQuery={initialQuery}
      title="Land Freight"
      subtitle="Land freight carrier contacts."
      endpoint="/land-freight"
      prefix="landfreight"
      singular="carrier"
      addLabel="Add carrier"
    />
  );
}
